module.exports = __webpack_public_path__ + "img/iconhomeactive.7935d480.svg";